<template>
  <section class="het-dal">
    <AudioPlayer
      class="audio-player"
      :src="require('@/assets/audio/helene_gedicht.mp3')"
      title="Luister naar Helene"
      trackTitle="gedicht-helene"
    ></AudioPlayer>
    <DalParagraph
      v-for="(paragraph, index) in paragraphs"
      :key="index"
      :p="paragraph"
    ></DalParagraph>
  </section>
</template>

<script>
import { scrollPositionMixin } from '@/mixins'
import DalParagraph from './DalParagraph'
import { AudioPlayer } from '@/components/chapter'

export default {
  name: 'UitHetDal',
  data () {
    return {
      paragraphs: [
        'Ik ben diep onder water',
        'Het is donker, complete stilte',
        'In m’n oren een ruis',
        'Op m’n borstkas een beklemd gevoel',
        'Ik ben bang om dood te gaan',
        'En ook bang voor mijn leven',
        'Daar in het diepe water',
        'Maar het donker wordt ooit licht',
        'Ondieper water',
        'Ik adem door een snorkel',
        'Ik zie door een duikbril',
        'Soms spoelt er een golf over me heen',
        'Ik verdrink weer',
        'Maar nu is het tijdelijk',
        'Ik ben nog niet boven water',
        'Maar ik weet dat het nabij is'
      ]
    }
  },
  mixins: [scrollPositionMixin],
  components: {
    DalParagraph,
    AudioPlayer
  }
}
</script>

<style lang="scss" scoped>
.het-dal {
  background-image: url(~@/assets/images/gradient.jpg);
  background-size: contain;
  background-repeat: repeat-x;
  background-position: top left;
  color: white;
  font-size: 20px;
  text-align: center;
  padding-top: 170px;
  padding-bottom: 170px;
  padding-left: 15px;
  padding-right: 15px;

  @media (min-width: 768px) {
    font-size: 32px;
    padding-top: 230px;
    padding-bottom: 230px;
  }
}
.audio-player {
  position: relative;
  top: -190px;
  text-align: center;

  @media (min-width: 768px) {
    top: -250px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dal/HetDal.vue